import React, { useEffect, useRef, useState } from "react";
import ReactTooltip from "react-tooltip";
import filterIcon from "../../../assets/filter.svg";
import FilterModal from "./FilterModal/FilterModal";
import { v4 } from "uuid";

// Styles
import "./TagFilter.scss";

export const CategoryType = {
  Boolean: "Boolean",
  Text: "Text",
  Checkbox: "Checkbox",
  RadioButton: "Radiobutton",
  Date: "Date",
};
const getTagFilterCategories = (listCategories) => {
  return [
    {
      id: v4(),
      name: "Category name",
      options: listCategories.map((category) => {
        return { id: v4(), name: category.name, isSelected: false, isSelectedTemp: false };
      }),
      filterCount: 0,
      tempFilterCount: 0,
      type: CategoryType.Checkbox,
    },
    {
      id: v4(),
      name: "Status",
      options: [
        { id: v4(), name: "Active" },
        { id: v4(), name: "Inactive" },
      ],
      selectedValue: null,
      tempSelectedValue: null,
      filterCount: 0,
      tempFilterCount: 0,
      type: CategoryType.RadioButton,
    },
    {
      id: v4(),
      name: "Created Date",
      type: CategoryType.Date,
      selectedStartValue: "",
      tempSelectedStartValue: "",
      selectedEndValue: "",
      tempSelectedEndValue: "",
      selectedMatrix: "Between",
      tempSelectedMatrix: "Between",
      defaultSelectedMatrix: "Between",
      matrix: ["On", "Before", "After", "Between"],
      filterCount: 0,
      tempFilterCount: 0,
    },
  ];
};

const TagFilter = ({ listCategories, handleFilterTags, filterCategories, setFilterCategories }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const filterRef = useRef();

  const handleClickOutsideOfFilter = (event) => {
    if (filterRef && filterRef.current && !filterRef.current.contains(event.target)) {
      setIsModalOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutsideOfFilter);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideOfFilter);
    };
  }, []);

  useEffect(() => {
    setFilterCategories(getTagFilterCategories(listCategories));
  }, [listCategories, setFilterCategories]);

  useEffect(() => {
    if (!isModalOpen) {
      setFilterCategories((categories) => {
        const tempCategories = [...categories];
        tempCategories.forEach((category) => {
          if (category.type === CategoryType.Checkbox) {
            category.options.forEach((option) => {
              option.isSelectedTemp = option.isSelected;
            });
          } else if (category.type === CategoryType.RadioButton) {
            category.tempSelectedValue = category.selectedValue;
          } else if (category.type === CategoryType.Date) {
            category.tempSelectedStartValue = category.selectedStartValue;
            category.tempSelectedEndValue = category.selectedEndValue;
            category.tempSelectedMatrix = category.selectedMatrix;
          }
          category.tempFilterCount = category.filterCount;
        });

        return tempCategories;
      });
    }
  }, [isModalOpen, setFilterCategories]);

  const isFilterApplied = () => {
    if (filterCategories) {
      let appliedFilters = 0;
      filterCategories.forEach((category) => {
        if (category.filterCount > 0) {
          appliedFilters += 1;
        }
      });
      return appliedFilters > 0;
    } else {
      return 0;
    }
  };

  const handleClear = () => {
    setFilterCategories((categories) => {
      const tempCategories = [...categories];
      tempCategories.forEach((category) => {
        if (category.type === CategoryType.Checkbox) {
          category.options.forEach((option) => {
            option.isSelectedTemp = false;
          });
        } else if (category.type === CategoryType.RadioButton) {
          category.tempSelectedValue = null;
        } else if (category.type === CategoryType.Date) {
          category.tempSelectedStartValue = "";
          category.tempSelectedEndValue = "";
          category.tempSelectedMatrix = category.defaultSelectedMatrix;
        }
        category.tempFilterCount = 0;
      });
      return tempCategories;
    });
  };

  return (
    <div ref={filterRef} className="tag-filter-container">
      <ReactTooltip id="filterTip" place="top" effect="solid">
        Filters
      </ReactTooltip>
      <button
        className={`btn-dropdown d-flex filter-button mr-4 ${isModalOpen ? "active" : ""}`}
        onClick={() => setIsModalOpen((isOpen) => !isOpen)}
      >
        <div className="text-auto-primary">
          <span className={isFilterApplied() ? "filter-applied" : "no-filter"}>
            <img src={filterIcon} alt="filter" />
          </span>
        </div>
        <div className="text-auto-secondary" data-tip data-for="filterTip">
          <div className={isFilterApplied() ? "filter-applied" : "no-filter"}>
            <img src={filterIcon} alt="filter" />
          </div>
        </div>
      </button>
      {isModalOpen ? (
        <FilterModal
          {...{
            filterCategories,
            handleFilterTags,
            setFilterCategories,
            setIsModalOpen,
            handleClear,
            isSearchCategory: false,
          }}
        />
      ) : null}
    </div>
  );
};

export default TagFilter;
